import { SessionData } from '@chegg/rio-sdk-web'
import { LOCAL_OR_PLAYGROUND } from '@src/utils/localOrPlayground'
import { getCheggUserUuid } from '@src/state/auth/selectors'
import { getPageSubGroup } from '@src/state/gtm/helper'
import { getCookieDomain } from '@src/state/site/selectors'
import { captureError } from '@src/utils/errors'
import { getOrSetVCookie } from '@src/utils/vCookie'
import { RootState } from '@src/state/types'
import { AllocationMap, getMemoizedFeatureFlags } from '../utils/getMemoizedFeatureFlags'
import { getAuthState, productMap, getSubscriptionStatus } from '../helpers'
import { getUpdatedView } from '../utils'
import { getExpCookie } from '../utils/getExpCookie'
import { RioEventFn } from '../types'

export const rioEvent: RioEventFn = (client, eventSpecs, config) => {
  const { stateUpdate, force = false, eventVersion } = config
  // Return a promise that resolves when the server has responded:
  return new Promise((resolve, reject) => {
    if (stateUpdate) {
      client.updateState(stateUpdate)
    }
    const sendEventParams = {
      ...eventSpecs,
      eventVersion,
      options: { force },
    }
    client
      .sendEvent(sendEventParams)
      .then(resolve)
      .catch(reject)
  })
}

export const getRioConfig = (state: RootState) => {
  let allocationMap: AllocationMap | undefined
  try {
    const featureFlags = getMemoizedFeatureFlags()
    allocationMap = featureFlags.allocationMap
  } catch (e) {}

  const LOG_EVENT_LAMBDA_URL = LOCAL_OR_PLAYGROUND
    ? 'https://analytics.test.cheggnet.com/rio-service-web/rest/rio-events/batch'
    : 'https://analytics.chegg.com/rio-service-web/rest/rio-events/batch'
  return {
    endpoint: LOG_EVENT_LAMBDA_URL,
    appId: 'wfe',
    property: state.site,
    authState: getAuthState(state),
    cheggUuid: getCheggUserUuid(state),
    testCells: allocationMap || {},
    uvn: getOrSetVCookie(getCookieDomain(state.site)) || '',
    clientExperiments: getExpCookie(),
    errorHandler: captureError,
    subscriptions: [
      { product: productMap[state.site], status: getSubscriptionStatus(state) },
    ],
    view: getUpdatedView({ site: state.site, page: getPageSubGroup(state) }),
  } as SessionData
}



// WEBPACK FOOTER //
// ./src/state/analytics/rsw/index.ts